import Icon from "@mui/material/Icon";

export interface PanelTabProps {
	icon: string;
}

const SideTabIcon: React.FC<PanelTabProps> = ({ icon }) => {
	return <Icon sx={{ color: "#aaabb2" }}>{icon}</Icon>;
};

export default SideTabIcon;
